// extracted by mini-css-extract-plugin
export default {"meinian-analysis-overview":"index_meinian-analysis-overview__vgBvx"};